import { Badge } from '@/shared/components/ui/badge';
import { cn } from '@/shared/lib/utils';

/**
 * 대조약(파랑) · 생동인정(초록) 배지 — M-11 카드 · M-12 드로어 · M-15 미리보기 공통.
 * small은 동일성분 목록 행 규격(10px · px 7)이다.
 */
export const DrugBadges = ({
  isReferenceDrug,
  isBioequivalent,
  small = false,
  className,
}: {
  isReferenceDrug?: boolean;
  isBioequivalent?: boolean;
  small?: boolean;
  className?: string;
}) => {
  if (!isReferenceDrug && !isBioequivalent) return null;
  const size = small ? 'px-[7px] text-[10px] leading-[15px]' : '';
  return (
    <span className={cn('flex gap-1.5', small && 'gap-[5px]', className)}>
      {isReferenceDrug && (
        <Badge tone="primary" className={size}>
          대조약
        </Badge>
      )}
      {isBioequivalent && (
        <Badge tone="success" className={size}>
          생동인정
        </Badge>
      )}
    </span>
  );
};
